module.exports = __webpack_public_path__ + "media/components/participants_components/static/Edit-39e3d34362754079566da2eb09337c4e.png";